export enum TeacherDeleteGroupAction {
  DeleteGroup = 'DeleteGroup',
  ReplaceTeacher = 'ReplaceTeacher',
  KeepRemainingTeacher = 'KeepRemainingTeacher',
}

export interface TeacherDeleteGroupActionRequest {
  groupId: string;
  action: TeacherDeleteGroupAction;
  replacementTeacherId: string;
}
